module.exports = __webpack_public_path__ + "static/media/F2.097abe2d.mp3";